import { Box, Typography, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Chip, Pagination, Stack, FormControl, InputLabel, Select, MenuItem, Alert, Snackbar, Tooltip, RadioGroup, FormControlLabel, Radio, Grid, Autocomplete } from "@mui/material";
import React, { Fragment, useState, useEffect } from "react";
import EditIcon from '@mui/icons-material/Edit';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { apiRequest } from "../../../../common/common";
import { Delete } from "@mui/icons-material";

export const CurrencyJSON = [
    { label: 'USD ($)', value: 'USD', symbol: '$' },
    { label: 'INR (₹)', value: 'INR', symbol: '₹' },
    { label: 'CAD ($)', value: 'CAD', symbol: '$' },
    { label: 'AED (د.إ)', value: 'AED', symbol: 'د.إ' },
    { label: 'AFN (؋)', value: 'AFN', symbol: '؋' },
    { label: 'ALL (L)', value: 'ALL', symbol: 'L' },
    { label: 'AMD (֏)', value: 'AMD', symbol: '֏' },
    { label: 'ANG (ƒ)', value: 'ANG', symbol: 'ƒ' },
    { label: 'AOA (Kz)', value: 'AOA', symbol: 'Kz' },
    { label: 'ARS ($)', value: 'ARS', symbol: '$' },
    { label: 'AUD ($)', value: 'AUD', symbol: '$' },
    { label: 'AWG (ƒ)', value: 'AWG', symbol: 'ƒ' },
    { label: 'AZN (₼)', value: 'AZN', symbol: '₼' },
    { label: 'BAM (КМ)', value: 'BAM', symbol: 'КМ' },
    { label: 'BBD ($)', value: 'BBD', symbol: '$' },
    { label: 'BDT (৳)', value: 'BDT', symbol: '৳' },
    { label: 'BGN (лв)', value: 'BGN', symbol: 'лв' },
    { label: 'BHD (.د.ب)', value: 'BHD', symbol: '.د.ب' },
    { label: 'BIF (Fr)', value: 'BIF', symbol: 'Fr' },
    { label: 'BMD ($)', value: 'BMD', symbol: '$' },
    { label: 'BND ($)', value: 'BND', symbol: '$' },
    { label: 'BOB (Bs.)', value: 'BOB', symbol: 'Bs.' },
    { label: 'BRL (R$)', value: 'BRL', symbol: 'R$' },
    { label: 'BSD ($)', value: 'BSD', symbol: '$' },
    { label: 'BTN (Nu.)', value: 'BTN', symbol: 'Nu.' },
    { label: 'BWP (P)', value: 'BWP', symbol: 'P' },
    { label: 'BYN (Br)', value: 'BYN', symbol: 'Br' },
    { label: 'BZD ($)', value: 'BZD', symbol: '$' },
    { label: 'CDF (Fr)', value: 'CDF', symbol: 'Fr' },
    { label: 'CHF (Fr)', value: 'CHF', symbol: 'Fr' },
    { label: 'CLP ($)', value: 'CLP', symbol: '$' },
    { label: 'CNY (¥)', value: 'CNY', symbol: '¥' },
    { label: 'COP ($)', value: 'COP', symbol: '$' },
    { label: 'CRC (₡)', value: 'CRC', symbol: '₡' },
    { label: 'CUC ($)', value: 'CUC', symbol: '$' },
    { label: 'CUP ($)', value: 'CUP', symbol: '$' },
    { label: 'CVE (Esc or $)', value: 'CVE', symbol: 'Esc or $' },
    { label: 'CZK (Kč)', value: 'CZK', symbol: 'Kč' },
    { label: 'DJF (Fr)', value: 'DJF', symbol: 'Fr' },
    { label: 'DKK (kr)', value: 'DKK', symbol: 'kr' },
    { label: 'DOP ($)', value: 'DOP', symbol: '$' },
    { label: 'DZD (د.ج)', value: 'DZD', symbol: 'د.ج' },
    { label: 'EGP (ج.م)', value: 'EGP', symbol: 'ج.م' },
    { label: 'ERN (Nfk)', value: 'ERN', symbol: 'Nfk' },
    { label: 'ETB (Br)', value: 'ETB', symbol: 'Br' },
    { label: 'EUR (€)', value: 'EUR', symbol: '€' },
    { label: 'FJD ($)', value: 'FJD', symbol: '$' },
    { label: 'FKP (£)', value: 'FKP', symbol: '£' },
    { label: 'GBP (£)', value: 'GBP', symbol: '£' },
    { label: 'GEL (₾)', value: 'GEL', symbol: '₾' },
    { label: 'GHS (₵)', value: 'GHS', symbol: '₵' },
    { label: 'GIP (£)', value: 'GIP', symbol: '£' },
    { label: 'GMD (D)', value: 'GMD', symbol: 'D' },
    { label: 'GNF (Fr)', value: 'GNF', symbol: 'Fr' },
    { label: 'GTQ (Q)', value: 'GTQ', symbol: 'Q' },
    { label: 'GYD ($)', value: 'GYD', symbol: '$' },
    { label: 'HKD ($)', value: 'HKD', symbol: '$' },
    { label: 'HNL (L)', value: 'HNL', symbol: 'L' },
    { label: 'HRK (kn)', value: 'HRK', symbol: 'kn' },
    { label: 'HTG (G)', value: 'HTG', symbol: 'G' },
    { label: 'HUF (Ft)', value: 'HUF', symbol: 'Ft' },
    { label: 'IDR (Rp)', value: 'IDR', symbol: 'Rp' },
    { label: 'ILS (₪)', value: 'ILS', symbol: '₪' },
    { label: 'IMP (£)', value: 'IMP', symbol: '£' },
    { label: 'IQD (ع.د)', value: 'IQD', symbol: 'ع.د' },
    { label: 'IRR (﷼)', value: 'IRR', symbol: '﷼' },
    { label: 'ISK (kr)', value: 'ISK', symbol: 'kr' },
    { label: 'JEP (£)', value: 'JEP', symbol: '£' },
    { label: 'JMD ($)', value: 'JMD', symbol: '$' },
    { label: 'JOD (د.ا)', value: 'JOD', symbol: 'د.ا' },
    { label: 'JPY (¥)', value: 'JPY', symbol: '¥' },
    { label: 'KES (Sh)', value: 'KES', symbol: 'Sh' },
    { label: 'KGS (л)', value: 'KGS', symbol: 'л' },
    { label: 'KHR (៛)', value: 'KHR', symbol: '៛' },
    { label: 'KMF (Fr)', value: 'KMF', symbol: 'Fr' },
    { label: 'KPW (₩)', value: 'KPW', symbol: '₩' },
    { label: 'KRW (₩)', value: 'KRW', symbol: '₩' },
    { label: 'KWD (د.ك)', value: 'KWD', symbol: 'د.ك' },
    { label: 'KYD ($)', value: 'KYD', symbol: '$' },
    { label: 'KZT (₸)', value: 'KZT', symbol: '₸' },
    { label: 'LAK (₭)', value: 'LAK', symbol: '₭' },
    { label: 'LBP (£)', value: 'LBP', symbol: '£' },
    { label: 'LKR (₨)', value: 'LKR', symbol: '₨' },
    { label: 'LRD ($)', value: 'LRD', symbol: '$' },
    { label: 'LSL (L)', value: 'LSL', symbol: 'L' },
    { label: 'LYD (ل.د)', value: 'LYD', symbol: 'ل.د' },
    { label: 'MAD (د.م.)', value: 'MAD', symbol: 'د.م.' },
    { label: 'MDL (L)', value: 'MDL', symbol: 'L' },
    { label: 'MGA (Ar)', value: 'MGA', symbol: 'Ar' },
    { label: 'MKD (ден)', value: 'MKD', symbol: 'ден' },
    { label: 'MMK (K)', value: 'MMK', symbol: 'K' },
    { label: 'MNT (₮)', value: 'MNT', symbol: '₮' },
    { label: 'MOP (P)', value: 'MOP', symbol: 'P' },
    { label: 'MRU (UM)', value: 'MRU', symbol: 'UM' },
    { label: 'MUR (₨)', value: 'MUR', symbol: '₨' },
    { label: 'MVR (Rf)', value: 'MVR', symbol: 'Rf' },
    { label: 'MWK (MK)', value: 'MWK', symbol: 'MK' },
    { label: 'MXN ($)', value: 'MXN', symbol: '$' },
    { label: 'MYR (RM)', value: 'MYR', symbol: 'RM' },
    { label: 'MZN (MT)', value: 'MZN', symbol: 'MT' },
    { label: 'NAD ($)', value: 'NAD', symbol: '$' },
    { label: 'NGN (₦)', value: 'NGN', symbol: '₦' },
    { label: 'NIO (C$)', value: 'NIO', symbol: 'C$' },
    { label: 'NOK (kr)', value: 'NOK', symbol: 'kr' },
    { label: 'NPR (₨)', value: 'NPR', symbol: '₨' },
    { label: 'NZD ($)', value: 'NZD', symbol: '$' },
    { label: 'OMR (ر.ع)', value: 'OMR', symbol: 'ر.ع' },
    { label: 'PAB (B/.)', value: 'PAB', symbol: 'B/.' },
    { label: 'PEN (S/.)', value: 'PEN', symbol: 'S/.' },
    { label: 'PGK (K)', value: 'PGK', symbol: 'K' },
    { label: 'PHP (₱)', value: 'PHP', symbol: '₱' },
    { label: 'PKR (₨)', value: 'PKR', symbol: '₨' },
    { label: 'PLN (zł)', value: 'PLN', symbol: 'zł' },
    { label: 'PYG (₲)', value: 'PYG', symbol: '₲' },
    { label: 'QAR (ر.ق)', value: 'QAR', symbol: 'ر.ق' },
    { label: 'RON (lei)', value: 'RON', symbol: 'lei' },
    { label: 'RSD (дин.)', value: 'RSD', symbol: 'дин.' },
    { label: 'RUB (₽)', value: 'RUB', symbol: '₽' },
    { label: 'RWF (Fr)', value: 'RWF', symbol: 'Fr' },
    { label: 'SAR (ر.س)', value: 'SAR', symbol: 'ر.س' },
    { label: 'SBD ($)', value: 'SBD', symbol: '$' },
    { label: 'SCR (₨)', value: 'SCR', symbol: '₨' },
    { label: 'SDG (ج.س.)', value: 'SDG', symbol: 'ج.س.' },
    { label: 'SEK (kr)', value: 'SEK', symbol: 'kr' },
    { label: 'SGD ($)', value: 'SGD', symbol: '$' },
    { label: 'SHP (£)', value: 'SHP', symbol: '£' },
    { label: 'SLL (Le)', value: 'SLL', symbol: 'Le' },
    { label: 'SOS (Sh)', value: 'SOS', symbol: 'Sh' },
    { label: 'SRD ($)', value: 'SRD', symbol: '$' },
    { label: 'SSP (£)', value: 'SSP', symbol: '£' },
    { label: 'STN (Db)', value: 'STN', symbol: 'Db' },
    { label: 'SVC (₡)', value: 'SVC', symbol: '₡' },
    { label: 'SYP (£)', value: 'SYP', symbol: '£' },
    { label: 'SZL (L)', value: 'SZL', symbol: 'L' },
    { label: 'THB (฿)', value: 'THB', symbol: '฿' },
    { label: 'TJS (SM)', value: 'TJS', symbol: 'SM' },
    { label: 'TMT (m)', value: 'TMT', symbol: 'm' },
    { label: 'TND (د.ت)', value: 'TND', symbol: 'د.ت' },
    { label: 'TOP (T$)', value: 'TOP', symbol: 'T$' },
    { label: 'TRY (₺)', value: 'TRY', symbol: '₺' },
    { label: 'TTD ($)', value: 'TTD', symbol: '$' },
    { label: 'TVD ($)', value: 'TVD', symbol: '$' },
    { label: 'TWD (NT$)', value: 'TWD', symbol: 'NT$' },
    { label: 'TZS (Sh)', value: 'TZS', symbol: 'Sh' },
    { label: 'UAH (₴)', value: 'UAH', symbol: '₴' },
    { label: 'UGX (Sh)', value: 'UGX', symbol: 'Sh' },
    { label: 'UYU ($)', value: 'UYU', symbol: '$' },
    { label: 'UZS (лв)', value: 'UZS', symbol: 'лв' },
    { label: 'VEF ($)', value: 'VEF', symbol: '$' },
    { label: 'VND (₫)', value: 'VND', symbol: '₫' },
    { label: 'VUV (Vt)', value: 'VUV', symbol: 'Vt' },
    { label: 'WST (T)', value: 'WST', symbol: 'T' },
    { label: 'XAF (Fr)', value: 'XAF', symbol: 'Fr' },
    { label: 'XCD ($)', value: 'XCD', symbol: '$' },
    { label: 'XOF (Fr)', value: 'XOF', symbol: 'Fr' },
    { label: 'XPF (Fr)', value: 'XPF', symbol: 'Fr' },
    { label: 'YER (ر.ي)', value: 'YER', symbol: 'ر.ي' },
    { label: 'ZAR (R)', value: 'ZAR', symbol: 'R' },
    { label: 'ZMW (ZK)', value: 'ZMW', symbol: 'ZK' },
    { label: 'ZWL ($)', value: 'ZWL', symbol: '$' },
];

// Detect if a field is currency-type by its name
const isCurrencyField = (fieldName = '') =>
    fieldName.toLowerCase().includes('currency');

const CustomField = () => {
    const [customFields, setCustomFields] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedField, setSelectedField] = useState(null);
    const [formData, setFormData] = useState({
        fieldName: '',
        dropdownOptions: [],
        type: '',
        description: ''
    });
    const [optionName, setOptionName] = useState('');
    const [optionValue, setOptionValue] = useState('');
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    // Pagination and filter states
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [descriptionFilter, setDescriptionFilter] = useState('');

    // Type options for radio buttons
    const typeOptions = [
        { value: 'Project', label: 'Project' },
        { value: 'Building', label: 'Building' },
        { value: 'Department', label: 'Department' },
        { value: 'Item', label: 'Item' }
    ];

    useEffect(() => {
        fetchCustomFields();
    }, []);

    const fetchCustomFields = async () => {
        setLoading(true);
        try {
            const response = await apiRequest('get', '/dropdown');
            setCustomFields(response.data?.data || []);
        } catch (error) {
            console.error('Error fetching custom fields:', error);
            showNotification(error?.response?.data?.error || error.message || 'Failed to fetch custom fields', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleOpenDialog = (field) => {
        setSelectedField(field);
        setFormData({
            fieldName: field.name,
            dropdownOptions: field.data || [],
            type: field.type || '',
            description: field.description || ''
        });
        setOptionName('');
        setOptionValue('');
        setSelectedCurrency(null);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setFormData({
            fieldName: '',
            dropdownOptions: [],
            type: '',
            description: ''
        });
        setOptionName('');
        setOptionValue('');
        setSelectedCurrency(null);
    };

    // Called when user picks a currency from Autocomplete
    const handleCurrencySelect = (_, currency) => {
        setSelectedCurrency(currency);
        if (currency) {
            setOptionName(currency.label);
            setOptionValue(currency.value);
        } else {
            setOptionName('');
            setOptionValue('');
        }
    };

    const handleAddOption = () => {
        if (optionName.trim() && optionValue.trim()) {
            const newOption = isCurrencyField(formData.fieldName) && selectedCurrency
                ? { name: selectedCurrency.label, value: selectedCurrency.value, symbol: selectedCurrency.symbol }
                : { name: optionName.trim(), value: optionValue.trim() };

            setFormData(prev => ({
                ...prev,
                dropdownOptions: [...prev.dropdownOptions, newOption]
            }));
            setOptionName('');
            setOptionValue('');
            setSelectedCurrency(null);
        } else {
            showNotification('Both name and value are required!', 'error');
        }
    };

    const handleRemoveOption = (index) => {
        const updatedOptions = formData.dropdownOptions.filter((_, i) => i !== index);
        setFormData({ ...formData, dropdownOptions: updatedOptions });
    };

    const handleEditOptionName = (index, newName) => {
        const updatedOptions = [...formData.dropdownOptions];
        updatedOptions[index] = { ...updatedOptions[index], name: newName };
        setFormData({ ...formData, dropdownOptions: updatedOptions });
    };

    const handleEditOptionValue = (index, newValue) => {
        const updatedOptions = [...formData.dropdownOptions];
        updatedOptions[index] = { ...updatedOptions[index], value: newValue };
        setFormData({ ...formData, dropdownOptions: updatedOptions });
    };

    const handleTypeChange = (event) => {
        setFormData({ ...formData, description: event.target.value });
    };

    const handleSubmit = async () => {
        if (!formData.fieldName.trim()) {
            showNotification('Please enter field name!', 'error');
            return;
        }
        if (!formData.type) {
            showNotification('Please select a type!', 'error');
            return;
        }
        if (formData.dropdownOptions.length === 0) {
            showNotification('Please add at least one dropdown option!', 'error');
            return;
        }

        const payload = {
            name: formData.fieldName.trim(),
            data: formData.dropdownOptions,
            type: formData.fieldName.trim()?.toLowerCase()?.replace(' ', '_'),
            description: formData.description,
            status: 'active'
        };

        setLoading(true);
        try {
            await apiRequest('put', `/dropdown/${selectedField.dropdown_id}`, payload);
            showNotification('Custom field updated successfully!', 'success');
            handleCloseDialog();
            fetchCustomFields();
        } catch (error) {
            console.error('Error updating custom field:', error);
            showNotification(error?.response?.data?.error || error.message || 'Failed to update custom field', 'error');
        } finally {
            setLoading(false);
        }
    };

    const showNotification = (message, severity) => {
        setSnackbar({ open: true, message, severity });
    };

    const handleCloseSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    // Filter and pagination logic
    const filteredFields = customFields.filter(field => {
        const matchesSearch = (field.name || '').toLowerCase().includes(searchTerm.toLowerCase());
        const matchesDescription = (field.description || '').toLowerCase().includes(descriptionFilter.toLowerCase());
        return matchesSearch && matchesDescription;
    });

    const groupedFields = filteredFields.reduce((groups, field) => {
        const description = field.description;
        if (!groups[description]) groups[description] = [];
        groups[description].push(field);
        return groups;
    }, {});

    const flattenedFields = Object.entries(groupedFields).flatMap(([description, fields]) =>
        fields.map(field => ({ ...field, groupDescription: description }))
    );

    const totalPages = Math.ceil(flattenedFields.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentFields = flattenedFields.slice(startIndex, startIndex + rowsPerPage);

    const handlePageChange = (_, value) => setCurrentPage(value);
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };

    const uniqueDescriptions = [...new Set(customFields.map(field => field.description || field.type || 'Uncategorized'))];

    const isCurrency = isCurrencyField(formData.fieldName);

    return (
        <Fragment>
            <Box mt={1} mb={3}>
                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                    <Typography variant='h4' style={{ fontWeight: 'bold' }}>
                        Custom Fields
                    </Typography>
                </Box>
                <Typography variant='body2' color='textSecondary' mt={1}>
                    Manage and edit dropdown fields for your application
                </Typography>
            </Box>

            {/* Search and Filter Controls */}
            <Box mb={3} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                <Box display="flex" gap={2} flexWrap="wrap">
                    <TextField
                        size="small"
                        placeholder="Search by field name..."
                        value={searchTerm}
                        onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                        sx={{ minWidth: 250 }}
                    />
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                        <InputLabel>Filter by Type</InputLabel>
                        <Select
                            value={descriptionFilter}
                            onChange={(e) => { setDescriptionFilter(e.target.value); setCurrentPage(1); }}
                            label="Filter by Type"
                        >
                            <MenuItem value="">All</MenuItem>
                            {uniqueDescriptions.map(desc => (
                                <MenuItem key={desc} value={desc}>{desc}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box display="flex" alignItems="center" gap={2}>
                    <Typography variant="body2">Rows per page:</Typography>
                    <FormControl size="small" sx={{ minWidth: 80 }}>
                        <Select value={rowsPerPage} onChange={handleRowsPerPageChange}>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={25}>25</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            {/* Table */}
            <TableContainer component={Paper} sx={{ mb: 3, overflowX: 'auto' }}>
                <Table>
                    <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>S.No</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Field Name</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Group By Field</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', width: '40%' }}>Dropdown Options (Name : Value)</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }} align="center">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading && currentFields.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center"><Typography>Loading...</Typography></TableCell>
                            </TableRow>
                        ) : currentFields.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center"><Typography>No custom fields found</Typography></TableCell>
                            </TableRow>
                        ) : (
                            currentFields.map((field, index) => (
                                <TableRow key={field.dropdown_id || index} hover>
                                    <TableCell>{startIndex + index + 1}</TableCell>
                                    <TableCell>
                                        <Typography variant="body2" fontWeight="medium">{field.name}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Chip label={field.description} size="small" color="primary" variant="outlined" />
                                    </TableCell>
                                    <TableCell>
                                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                            {(field.data || []).map((option, idx) => (
                                                <Chip
                                                    key={idx}
                                                    label={option.symbol ? `${option.name} (${option.symbol})` : `${option.name}: ${option.value}`}
                                                    size="small"
                                                    variant="outlined"
                                                    icon={<ArrowDropDownCircleIcon />}
                                                    title={`Name: ${option.name}, Value: ${option.value}${option.symbol ? `, Symbol: ${option.symbol}` : ''}`}
                                                />
                                            ))}
                                        </Stack>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Edit">
                                            <IconButton color="primary" onClick={() => handleOpenDialog(field)} size="small">
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {totalPages > 1 && (
                <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        size="large"
                        showFirstButton
                        showLastButton
                    />
                </Box>
            )}

            {/* Edit Dialog */}
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>Edit Custom Field</DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Field Name"
                                    value={formData.fieldName}
                                    onChange={(e) => setFormData({ ...formData, fieldName: e.target.value })}
                                    required
                                    disabled
                                    placeholder="e.g., Department, Category, Status"
                                />
                            </Grid>
                        </Grid>

                        <Box mt={3} mb={3}>
                            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                Select Type
                            </Typography>
                            <RadioGroup row value={formData.description} onChange={handleTypeChange}>
                                {typeOptions.map((option) => (
                                    <FormControlLabel
                                        key={option.value}
                                        value={option.value}
                                        control={<Radio />}
                                        label={option.label}
                                    />
                                ))}
                            </RadioGroup>
                        </Box>

                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                            Dropdown Options
                        </Typography>
                        <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 2 }}>
                            {isCurrency
                                ? 'Select a currency — label, value, and symbol will be added automatically'
                                : 'Add options with label and value pairs'}
                        </Typography>

                        {/* Currency Autocomplete OR manual fields */}
                        {isCurrency ? (
                            <Box display="flex" gap={2} mb={2} alignItems="flex-start">
                                <Autocomplete
                                    fullWidth
                                    options={CurrencyJSON}
                                    getOptionLabel={(option) => option.label}
                                    value={selectedCurrency}
                                    onChange={handleCurrencySelect}
                                    isOptionEqualToValue={(option, val) => option.value === val?.value}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                            label="Select Currency"
                                            placeholder="Search by currency code or name..."
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <Box component="li" {...props}>
                                            <Typography variant="body2" sx={{ mr: 1, fontWeight: 600, minWidth: 45 }}>
                                                {option.value}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                                                {option.symbol}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {option.label}
                                            </Typography>
                                        </Box>
                                    )}
                                />
                                <Button
                                    variant="outlined"
                                    onClick={handleAddOption}
                                    disabled={!selectedCurrency}
                                    sx={{ minWidth: '80px', whiteSpace: 'nowrap' }}
                                >
                                    Add
                                </Button>
                            </Box>
                        ) : (
                            <Box display="flex" gap={2} mb={2} alignItems="flex-start">
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Label"
                                    value={optionName}
                                    onChange={(e) => setOptionName(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleAddOption()}
                                    placeholder="Enter option label"
                                />
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Value"
                                    value={optionValue}
                                    onChange={(e) => setOptionValue(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleAddOption()}
                                    placeholder="Enter option value"
                                />
                                <Button
                                    variant="outlined"
                                    onClick={handleAddOption}
                                    disabled={!optionName.trim() || !optionValue.trim()}
                                    sx={{ minWidth: '80px' }}
                                >
                                    Add
                                </Button>
                            </Box>
                        )}

                        {formData.dropdownOptions.length > 0 ? (
                            <Paper variant="outlined" sx={{ p: 2, maxHeight: 300, overflow: 'auto' }}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Name</strong></TableCell>
                                            <TableCell><strong>Value</strong></TableCell>
                                            {isCurrency && <TableCell><strong>Symbol</strong></TableCell>}
                                            <TableCell align="center" width="50"><strong>Action</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {formData.dropdownOptions.map((option, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell>
                                                    <TextField
                                                        size="small"
                                                        value={option.name}
                                                        onChange={(e) => handleEditOptionName(index, e.target.value)}
                                                        variant="standard"
                                                        fullWidth
                                                        disabled={isCurrency}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        size="small"
                                                        value={option.value}
                                                        onChange={(e) => handleEditOptionValue(index, e.target.value)}
                                                        variant="standard"
                                                        fullWidth
                                                        disabled={isCurrency}
                                                    />
                                                </TableCell>
                                                {isCurrency && (
                                                    <TableCell>
                                                        <Typography variant="body2">{option.symbol || '—'}</Typography>
                                                    </TableCell>
                                                )}
                                                <TableCell align="center">
                                                    <IconButton size="small" color="error" onClick={() => handleRemoveOption(index)}>
                                                        <Delete fontSize="small" />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Paper>
                        ) : (
                            <Alert severity="info" sx={{ mt: 2 }}>
                                No options added yet. Please add at least one dropdown option.
                            </Alert>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} disabled={loading}>Cancel</Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={loading || !formData.fieldName.trim() || !formData.type || formData.dropdownOptions.length === 0}
                    >
                        {loading ? 'Updating...' : 'Update'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Fragment>
    );
};

export default CustomField;